import React from 'react';

const BaseButton = ({ 
  children, 
  onClick, 
  type = "button",
  variant = "primary",
  size = "md",
  disabled = false,
  loading = false,
  icon = null,
  iconPosition = "left",
  fullWidth = false,
  className = "",
  ...props 
}) => {
  const getVariantClasses = () => {
    switch (variant) {
      case "primary":
        return "bg-vox-green-600 hover:bg-vox-green-700 text-white focus:ring-vox-green-500";
      case "secondary":
        return "bg-vox-blue-600 hover:bg-vox-blue-700 text-white focus:ring-vox-blue-500";
      case "outline":
        return "bg-transparent border border-vox-green-600 text-vox-green-600 hover:bg-vox-green-50 dark:hover:bg-vox-green-900/20 focus:ring-vox-green-500";
      case "ghost":
        return "bg-transparent text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 focus:ring-gray-500";
      case "danger":
        return "bg-red-600 hover:bg-red-700 text-white focus:ring-red-500";
      case "warning":
        return "bg-yellow-600 hover:bg-yellow-700 text-white focus:ring-yellow-500";
      default:
        return "bg-vox-green-600 hover:bg-vox-green-700 text-white focus:ring-vox-green-500";
    }
  };

  const getSizeClasses = () => {
    switch (size) {
      case "xs":
        return "px-2 py-1 text-xs";
      case "sm":
        return "px-3 py-1.5 text-sm";
      case "md":
        return "px-4 py-2 text-sm";
      case "lg":
        return "px-6 py-3 text-base";
      case "xl":
        return "px-8 py-4 text-lg";
      default:
        return "px-4 py-2 text-sm";
    }
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        inline-flex items-center justify-center font-semibold rounded-lg
        focus:outline-none focus:ring-2 focus:ring-offset-2
        transition-all duration-200
        ${getVariantClasses()}
        ${getSizeClasses()}
        ${fullWidth ? 'w-full' : ''}
        ${disabled || loading ? 'opacity-60 cursor-not-allowed' : ''}
        ${className}
      `}
      {...props}
    >
      {loading && (
        <svg className="animate-spin -ml-1 mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      )}
      
      {!loading && icon && iconPosition === "left" && (
        <span className="mr-2">{icon}</span>
      )}
      
      {children}
      
      {!loading && icon && iconPosition === "right" && (
        <span className="ml-2">{icon}</span>
      )}
    </button>
  );
};

export default BaseButton; 